import { toastr } from 'react-redux-toastr'

const errorOptions = {
  timeOut: 5000
}

const warningOptions = {
  timeOut: 5000
}

const infoOptions = {
  timeOut: 2000
}

const successOptions = {
  timeOut: 2000
}

const confirmOptions = {
  okText: 'Yes',
  cancelText: 'No'
}

export const ShowErrorDispatch = (dispatch) => {
  return ShowError
}

export const ShowWarningDispatch = (dispatch) => {
  return ShowWarning
}

export const ShowInfoDispatch = (dispatch) => {
  return ShowInfo
}

export const ShowSuccessDispatch = (dispatch) => {
  return ShowSuccess
}

export const ShowConfirmDispatch = (dispatch) => {
  return ShowConfirm
}

export const ShowCustomDispatch = (dispatch) => {
  return (message, options) => {

  }
}

export const ShowLoadingDispatch = (dispatch) => {
  return (message, options) => {

  }
}

export const ClearLoadingDispatch = (dispatch) => {
  return (message, options) => {

  }
}

export const ShowError = (message, options) => {
  toastr.error('Error', message, options || errorOptions)
}

export const ShowWarning = (message, options) => {
  toastr.warning('Warning', message, options || warningOptions)
}

export const ShowInfo = (message, options) => {
  toastr.info('Info', message, options || infoOptions)
}

export const ShowSuccess = (message, options) => {
  toastr.success('Success', message, options || successOptions)
}

export const ShowConfirm = (question, onOk, onCancel, options) => {
  const opts = {
    ...confirmOptions,
    ...options,
    onOk: onOk,
    onCancel: onCancel
  }
  toastr.confirm(question, opts)
}
